import { render, staticRenderFns } from "./statistics.vue?vue&type=template&id=c116e524&"
import script from "./statistics.vue?vue&type=script&lang=js&"
export * from "./statistics.vue?vue&type=script&lang=js&"
import style0 from "./statistics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports